import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Heading } from "@chakra-ui/layout";
import React from "react";
import ResponsesTable from "./responses-table";
const EmailResponses = ({ campaignEmailId }) => {
    return (_jsxs(_Fragment, { children: [_jsx(Box, Object.assign({ mb: "2", mt: "8" }, { children: _jsx(Heading, Object.assign({ size: "lg", fontSize: "2xl" }, { children: "Responses" })) })), _jsx(ResponsesTable, { campaignEmailId: campaignEmailId })] }));
};
export default EmailResponses;
